import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import validators from '../../utils/validators';
import Overlay from '../../forms/_common/Overlay';
import FormErrors from '../../forms/_common/FormErrors';
import RequestError from '../../forms/_common/RequestError';
import ErrorMessage from '../../forms/_common/ErrorMessage';
import SuccessMessage from '../../forms/_common/SuccessMessage';
import Form from './Form';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Confirmation from './Confirmation';
import { useQueryMutation } from '@lore/query-connect';

export default function Dialog(props) {
  const [data, setData] = useState({
    name: '',
    phoneNumber: '',
    website: '',
    addressLine1: '',
    city: '',
    state: '',
    zipCode: '',
    latitude: undefined,
    longitude: undefined,
    isActive: true

  });
  const [showErrors, setShowErrors] = useState(false);

  const mutation = useQueryMutation('site.create');
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      // props.onClose();
      props.onSubmit && props.onSubmit(request);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate(data);
  }

  function onChange(name, value) {
    if (name === 'state') {
      value = value.toUpperCase().replace(/\s/g, '')
    }
    if (['phoneNumber', 'website', 'zipCode'].includes(name)) {
      value = value.trim();
    }
    setData(prev => ({ ...prev, [name]: value }));
  }

  return (
    <DialogTemplate className="w-screen max-w-screen-sm">
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          name: [validators.isRequired],
          phoneNumber: [validators.isRequired],
          website: [validators.isRequired,validators.isUrl],
          addressLine1: [validators.isRequired],
          city: [validators.isRequired],
          state: [validators.isRequired, validators.isLength(2), validators.isAlpha],
          zipCode: [validators.isRequired, validators.minLength(5)],
          latitude: [validators.isBetween(-90, 90)],
          longitude: [validators.isBetween(-180, 180)]
        }}>
          {({errors, hasError}) => {
            if (success) {
              return (
                <Confirmation
                  data={data}
                  onClose={() => {
                    props.onClose();
                    setTimeout(function() {
                      props.onSubmit && props.onSubmit(request)
                    }, 300);
                  }}
                />
              );
            }

            return (
              <Form
                data={data}
                errors={errors}
                showErrors={showErrors}
                onChange={onChange}
                onSubmit={() => hasError ? setShowErrors(true) : onSubmit()}
                onClose={props.onClose}
                alert={error ? (
                  <RequestError request={request}/>
                ) : showErrors ? (
                  <ErrorMessage>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : (false && success) ? (
                  <SuccessMessage>
                    Note updated.
                  </SuccessMessage>
                ) : null}
              />
            );
          }}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
